module.exports = __webpack_public_path__ + "img/Spinnennetz.f2d5f124.jpg";